// After logging out (desk user menu, or the website /logout page), go to the website home page
// instead of the login page. An expired session still goes to the login page.
(() => {
	const go_home = () => (window.location.href = "/");

	frappe.logout = function () {
		frappe.call({
			method: "logout",
			callback: (r) => !r.exc && go_home(),
		});
	};

	const Application = frappe.Application;
	if (!Application || Application.prototype.__logout_home_patched) return;

	Application.prototype.logout = function () {
		this.logged_out = true;
		frappe.confirm(__("Are you sure you want to log out?"), () =>
			frappe.call({
				method: "logout",
				callback: (r) => !r.exc && go_home(),
			})
		);
	};
	Application.prototype.__logout_home_patched = true;
})();
